import React, { useState } from 'react';
import { useRebuttals } from '@context/rebuttals';
import { SidebarButton, DropdownStyle, RebuttalListItem } from './styles';
import { updateCurrentSlide } from '@utils/currentSlide';
import { useSlideSequenceMutation } from '@mutations/scenarios';
import { useUser } from '@context/user';
import { useClient } from '@context/presentation';
import { useQueryClient } from 'react-query';
import { usePresentation } from '@context/presentation';
import { QUERY_KEYS, PresentationType, SLIDES_WITH_CREDIT_DATA, UNAVAILABLE_CS_FIRM } from '@constants';

export const RebuttalDropdown = ({ rebuttalType }) => {
    const queryClient = useQueryClient();
    const { presentationType, client, profile, presentationId } = usePresentation();
    const { firm } = client;
    const { slideSequenceQuery } = QUERY_KEYS;
    const { CUSTOMER_SERVICE_PRESENTATION } = PresentationType;
    const { scenarioId } = useUser();
    const [expanded, setExpanded] = useState(false);
    const { slideId, dispatch, selectedRebuttals } = useRebuttals(rebuttalType);
    const slideSequenceMutation = useSlideSequenceMutation();
    const isCsPresentation = presentationType === CUSTOMER_SERVICE_PRESENTATION;
    const isLimitedCsPresentation = isCsPresentation && firm === UNAVAILABLE_CS_FIRM;
 
    const handleSlideClick = async (slide) => {
        await updateCurrentSlide(dispatch, slide.id, slideId, presentationId, profile);

        // To-do: break out into util
        if (!isCsPresentation) {
            const { id, name, isRequired } = slide;
        
            const slideSequence = queryClient.getQueryData([slideSequenceQuery, scenarioId]);
            const alreadyAdded = slideSequence.find(existingSlide => existingSlide.id === id);
    
            if (!alreadyAdded) {
                const newSequence = [...slideSequence, { id, name, isRequired }];
                
                slideSequenceMutation.mutate({ sequence: newSequence, isDefault: false, scenarioId });
            }
        }
    };

    return (
        <DropdownStyle>
            <SidebarButton
                expanded={expanded}
                onClick={() => setExpanded(!expanded)}>
                    {rebuttalType}
            </SidebarButton>
            {
                expanded && (
                    <ul>
                        {
                            selectedRebuttals
                                .filter(slide => {
                                    return isLimitedCsPresentation ? !SLIDES_WITH_CREDIT_DATA.includes(slide.id) : slide;
                                }).map(slide => (
                                    <RebuttalListItem
                                        selected={slideId === slide.id}
                                        key={slide.id}
                                        onClick={() => handleSlideClick(slide)} >
                                            {slide.name}
                                    </RebuttalListItem>
                            ))
                        }
                    </ul>
                )
            }
        </DropdownStyle>
    );
};

export default RebuttalDropdown;